var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { i18n } from '@easydata/core';
import { ExprTag } from '@easyquery/core';
import { createBrowserEvent, domel } from '@easydata/ui';
import { ColumnRendererCP } from './column_renderer_cp';
import { browserUtils } from '../../../utils/browser_utils';
var SimpleColumnRendererCP = /** @class */ (function (_super) {
    __extends(SimpleColumnRendererCP, _super);
    function SimpleColumnRendererCP() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SimpleColumnRendererCP.prototype.getClassesToAdd = function () {
        return _super.prototype.getClassesToAdd.call(this) + " " + this.cssPrefix + "-row " + this.cssPrefix + "-row-column-entattr";
    };
    SimpleColumnRendererCP.prototype.renderExpressionBlock = function () {
        var _this = this;
        return domel("div")
            .addClass(this.cssPrefix + "-expr-block")
            .addClass(browserUtils.getMobileCssClass())
            .addChild('div', function (builder) { return builder
            .addClass(_this.cssPrefix + "-colelement", _this.cssPrefix + "-attrelement")
            .addClass(browserUtils.getMobileCssClass())
            .addChildElement(_this.renderBaseExpression()); })
            .toDOM();
    };
    SimpleColumnRendererCP.prototype.renderBaseExpression = function () {
        var _this = this;
        var attrCaption = this.getAttributeCaption(this.baseAttr);
        if (this.isEditable()) {
            return domel('a')
                .attr('href', 'javascript:void(0)')
                .title(attrCaption)
                .text(attrCaption) //TO DO:add localization
                .on('click', function (ev) {
                ev.stopPropagation();
                _this.panel.showEntitiesMenu({
                    anchor: ev.target,
                    selectedIds: null,
                    itemSelectedCallback: _this.baseExpressionItemSelectedCallback.bind(_this),
                    itemFilterCallback: function (item) { return item.id !== '__AddAll__'; }
                });
                return false;
            })
                .toDOM();
        }
        return domel('span')
            .text(attrCaption)
            .title(attrCaption)
            .toDOM();
    };
    SimpleColumnRendererCP.prototype.baseExpressionItemSelectedCallback = function (data, item) {
        var attrid = data.id;
        this.column.expr.setValue(attrid, true);
        this.column.caption = '';
        this.fireColumnChanged();
        return false;
    };
    SimpleColumnRendererCP.prototype.getUIS = function () {
        var arg = this.column.expr.args[0];
        if (arg) {
            var model = this.panel.getContext().getModel();
            return model.checkAttrProperty(arg.value, "useInSorting");
        }
        else {
            return true;
        }
    };
    SimpleColumnRendererCP.prototype.changeTypeHandler = function (ev) {
        var _this = this;
        this.keepShowingButtons = true;
        this.functionMenu.showMenu({
            anchor: ev.target,
            selectedIds: null,
            itemSelectedCallback: function (data, items) {
                _this.processExtraButtonMenuItems(data.id, null);
                return false;
            },
            menuClosedCallback: function () {
                _this.keepShowingButtons = false;
                if (!_this.isMouseOverBlock) {
                    _this.element.dispatchEvent(createBrowserEvent('mouseleave'));
                }
            }
        });
    };
    SimpleColumnRendererCP.prototype.changeTypeToCustomSql = function () {
        var _this = this;
        var query = this.column.getQuery();
        query.changeColumnType(this.column, ExprTag.CustomSql);
        var parentElement = this.element.parentElement;
        setTimeout(function () {
            //focus CustomSQL Edit
            var newElement = parentElement.querySelector("div[data-id='" + _this.column.id + "']  div[class*='" + _this.cssPrefix + "-expr-block']  div[class*='" + _this.cssPrefix + "-colelement']  a");
            if (newElement)
                newElement.click();
        }, 500);
        this.fireColumnChanged();
    };
    SimpleColumnRendererCP.prototype.changeTypeToAggr = function (funcId) {
        var query = this.column.getQuery();
        query.changeColumnType(this.column, ExprTag.AggregateFunction, { funcId: funcId });
        this.fireColumnChanged();
    };
    SimpleColumnRendererCP.prototype.processExtraButtonMenuItems = function (action, evt) {
        if (action === "CUSTOMSQL") {
            this.changeTypeToCustomSql();
        }
        else {
            this.changeTypeToAggr(action);
        }
        return true;
    };
    SimpleColumnRendererCP.prototype.getExtraButtonMenuItems = function () {
        var items = [];
        var funcs = this.panel.getContext().getModel().getAggrFunctions();
        var toInclude = true;
        var funcAllowed = true;
        var item = null;
        var attribute = this.getAttribute();
        var funcCaption;
        for (var _i = 0, funcs_1 = funcs; _i < funcs_1.length; _i++) {
            var func = funcs_1[_i];
            toInclude = func.getAppliedTypesOrDefault().indexOf(attribute.dataType) >= 0;
            if (this.column.expr.func === func.id && !toInclude) {
                funcAllowed = false;
            }
            if (toInclude) {
                funcCaption = this.panel.getContext().getModel().getAggrFunctionCaption(func.id);
                item = {
                    id: func.id,
                    text: funcCaption
                };
                items.push(item);
            }
        }
        for (var idx = 0; idx < funcs.length; idx++) {
            if (!funcs[idx])
                continue;
        }
        if (!funcAllowed) {
            this.column.expr.func = items[0].id;
        }
        //Add "Custom Expression" menu
        var columnsPanel = this.panel;
        if (columnsPanel.areCustomExpressionsAllowed()) {
            item = {
                id: 'CustomSqlDivider',
                text: '---'
            };
            items.push(item);
            funcCaption = i18n.getText('CustomExpression');
            item = {
                id: 'CUSTOMSQL',
                text: funcCaption
            };
            items.push(item);
        }
        return [{
                id: '__group',
                text: i18n.getText('ColTypeGroup'),
                items: items
            }];
    };
    return SimpleColumnRendererCP;
}(ColumnRendererCP));
export { SimpleColumnRendererCP };
//# sourceMappingURL=simple_column_renderer.js.map